import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { logGeneralError } from '../../utils/sentry';
import { validateMerchant } from '../../utils/serverAPI/validateMerchant';
import { safeStringify } from '../../utils/safeStringify';
import { type WidgetMeta } from '../../types/WidgetProps';
import { type AuthParams } from '../../types/AuthParams';
import { type WidgetFedopsLogger } from '../../components/Provider/Fedops/FedopsProvider';
import { InteractionName } from '../../types/InteractionName';
import { extractHostname } from '../../utils/url/extractHostname';
import {
  applePayMerchantValidationError,
  applePayMerchantValidationSucceeded,
  applePayStartMerchantValidation,
} from '../../utils/bi/events/applePay';
import { type BiLogger } from '../../components/Provider/BiLogger/BiLogger';

/**
 * Domain validation handler
 * @param data Object
 * @param auth
 * @param auth.appInstance Signed instance that is used as Authorization header in REST API calls
 * @param auth.revalidateAppInstance Mechanism to revalidate the expired signed instance
 */
export const validateMerchantHandler =
  (
    data: {
      meta: WidgetMeta;
      domain: string;
    },
    biLogger: BiLogger,
    auth: AuthParams,
    fedopsLogger: WidgetFedopsLogger,
  ) =>
  async (event: ApplePayJS.ApplePayValidateMerchantEvent) => {
    const { domain, meta } = data;
    const { appDefId, cartId, appInstanceId } = meta;
    try {
      biLogger.report(applePayStartMerchantValidation, {
        checkoutType: 'express',
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.ApplePay,
        cartId,

        orderSnapshotId: undefined as any, // TODO[bi]
        transactionId: undefined as any, // TODO[bi]
        isPartner: undefined as any, // TODO[bi]
        amount: undefined as any, // TODO[bi]
        currency: undefined as any, // TODO[bi]
      });
      fedopsLogger.interactionStarted(InteractionName.ApplePayValidateMerchant);
      const sessionObj = await validateMerchant(
        {
          accountId: `${appDefId}:${appInstanceId}`,
          validationUrl: event.validationURL,
          domain: extractHostname(domain),
        },
        auth,
      );
      fedopsLogger.interactionEnded(InteractionName.ApplePayValidateMerchant);
      biLogger.report(applePayMerchantValidationSucceeded, {
        cartId,
        paymentmethod: PaymentMethod.ApplePay,
        paymentProvider: PaymentProvider.WixPayUS,
        checkoutType: 'express',

        orderSnapshotId: undefined as any, // TODO[bi]
        transactionId: undefined as any, // TODO[bi]
        isPartner: undefined as any, // TODO[bi]
        amount: undefined as any, // TODO[bi]
        currency: undefined as any, // TODO[bi]
      });
      return sessionObj;
    } catch (error) {
      const sentryId = logGeneralError({
        message: '[ApplePay] validateMerchant failed',
        payload: error,
      });
      biLogger.report(applePayMerchantValidationError, {
        checkoutType: 'express',
        errorReason: safeStringify({
          message: error.response?.data?.message || error.message,
          status: error.response?.status,
          requestId: error.requestId,
          sentryId,
        }),
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.ApplePay,
        cartId,

        orderSnapshotId: undefined as any, // TODO[bi]
        transactionId: undefined as any, // TODO[bi]
        isPartner: undefined as any, // TODO[bi]
        amount: undefined as any, // TODO[bi]
        currency: undefined as any, // TODO[bi]
      });

      return error;
    }
  };
